import TriBar from './TriBar.js';

/*
 * The ECG brand lockup. The mark is the crow from the Jul 2026 brand suite
 * (public/brand/suite/crow-mark.png); the wordmark is typeset live (Montserrat ExtraBold, per BRAND.md
 * typography) so the one component covers the reversed treatment on dark
 * surfaces — the shipped horizontal SVG carries charcoal text and only works
 * on light ground.
 *
 * Wide viewports get the horizontal lockup, narrow get the icon alone.
 */
export default function Logo({
  surface = 'dark',
  className = '',
}: {
  /** 'dark' = reversed (light wordmark); 'light' = charcoal wordmark. */
  surface?: 'dark' | 'light';
  className?: string;
}) {
  const wordmark = surface === 'dark' ? 'text-ecg-light' : 'text-ecg-charcoal';
  return (
    <span className={`flex items-center gap-2.5 ${className}`}>
      <img
        src="/brand/suite/crow-mark.png"
        alt="Early Crow Games"
        className="h-11 w-11 shrink-0 object-contain"
      />
      <span aria-hidden className={`hidden flex-col sm:flex ${wordmark}`}>
        <span className="font-brand text-lg font-extrabold uppercase leading-none tracking-[0.09em]">
          Early Crow
        </span>
        <span className="mt-1 font-brand text-[10px] font-extrabold uppercase leading-none tracking-[0.42em]">
          Games
        </span>
        <TriBar className="mt-1" />
      </span>
    </span>
  );
}
